import { render, staticRenderFns } from "./high-light.vue?vue&type=template&id=aa2c4960&"
import script from "./high-light.vue?vue&type=script&lang=js&"
export * from "./high-light.vue?vue&type=script&lang=js&"
import style0 from "./high-light.vue?vue&type=style&index=0&id=aa2c4960&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports